export default {"src":"/_next/static/image/public/images/ic_contactus_email.a3265fc640dc80695d2844fbe346572c.svg","height":60,"width":60};